






































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { DataApi } from '../models/Add.model';

@Component({ components: {} })
export default class TabGeneral extends Vue {
  @Prop({ required: true, default: {} }) data!: DataApi;

  mounted() {
    Object.entries(this.data).forEach(
      ([key, val]) => (this.data[key as keyof DataApi] = val || ' ')
    );
  }
}
